import Flickity from "flickity-fade";
import "flickity-imagesloaded";

(function($) {


    if ( $('.resident-carousel').length ) {
        $('.resident-carousel').each(function() {
            new Flickity(this, {
                // options
                cellAlign: 'left',
                contain: true,
                draggable: true,
                wrapAround: true,
                prevNextButtons: true,
                pageDots: true,
                arrowShape: {
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 70, y2: 40,
                    x3: 30,
                },
            });
        });


    }

})(jQuery);
